"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ModalDialog_1 = __importDefault(require("./ModalDialog"));
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOpen = function () {
            _this.setState({ open: true });
        };
        _this.handleClose = function () {
            var onClose = _this.props.onClose;
            _this.setState({ open: false });
            if (onClose) {
                onClose();
            }
        };
        _this.state = { open: props.startOpen || false };
        return _this;
    }
    Modal.prototype.getChildren = function () {
        var _this = this;
        var children = this.props.children;
        return react_1.default.Children.map(children, function (child) {
            if (react_1.default.isValidElement(child) && child.type === ModalDialog_1.default.Heading) {
                return react_1.default.cloneElement(child, { onClose: _this.handleClose });
            }
            return child;
        });
    };
    Modal.prototype.render = function () {
        var _a = this.props, appElement = _a.appElement, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedby = _a.ariaDescribedby, bodyOpenClassName = _a.bodyOpenClassName, className = _a.className, contentRef = _a.contentRef, entrance = _a.entrance, style = _a.style, trigger = _a.trigger, width = _a.width, registerModal = _a.registerModal;
        var open = this.state.open;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            trigger(this.handleOpen),
            open && (react_1.default.createElement(ModalDialog_1.default, { ariaLabelledBy: ariaLabelledBy, ariaDescribedby: ariaDescribedby, appElement: appElement, bodyOpenClassName: bodyOpenClassName, className: className, contentRef: contentRef, entrance: entrance, style: style, width: width, onClose: this.handleClose, registerModal: registerModal }, this.getChildren()))));
    };
    Modal.Heading = ModalDialog_1.default.Heading;
    Modal.Body = ModalDialog_1.default.Body;
    Modal.LoaderBody = ModalDialog_1.default.LoaderBody;
    Modal.Footer = ModalDialog_1.default.Footer;
    return Modal;
}(react_1.default.Component));
exports.default = Modal;
